export const HEATMAP_BLUE_COLOR_STOPS = Object.freeze({
  0: '#FFFFFF',
  5: '#F9FCFF',
  10: '#F2F9FF',
  15: '#ECF6FF',
  20: '#E6F3FF',
  25: '#DCEEFF',
  30: '#D2E9FF',
  35: '#C0E0FF',
  40: '#B2D9FF',
  45: '#A5D3FE',
  50: '#97CCFE',
  55: '#71B3FE',
  60: '#58A6FF',
  65: '#008AFF',
  70: '#0080FF',
  75: '#0077FF',
  80: '#0055FF',
  85: '#0032D7',
  90: '#0726AA',
  95: '#0D189C',
  100: '#130A8F',
});
